import React, { useEffect, useState } from "react";
import documentimg from "../../../assets/images/doc.jpg";
import {
  InputAdornment,
  Tooltip,
  Box,
  Skeleton,
  CssBaseline,
  Popover,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { TextField, ThemeProvider, createTheme } from "@mui/material";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import { ToastContainer, toast } from "react-toastify";
import { Formik, useFormik } from "formik";
import AccountRadioButton from "./AccountRadioButton";
import { dateFormatter } from "../../../helper/helper";
import Swal from "sweetalert2";

const Document = () => {
  const [data, setData] = useState([]);
  // console.log("data------", data);
  const UserId = localStorage.getItem("UserId");
 const ImageClick=()=>{
  // alert("333")
 }
  async function GetDocument(values) {
    try {
      // setOpen(true);
      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/user/profile/details?cpId=${UserId}`,

        // `http://192.168.167.66:5001/admin/v1/user/profile/details?cpId=${UserId}`
      );
      // console.log("------resultssss4", result);
      if (result.data.statusDescription.statusCode == 200) {
        setData(result.data.userDetail.documentList);

        // setData(result.data.userDetail);

        // console.log("updatedata76",updatedata)
        // console.log({itemapproved})
        // toast.success(result.data.statusDescription.description, {
        //   theme: "colored",
        // });
      } else {
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:result.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // toast.error("Please check your network");
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // const openInNewTab = (url) => {
  //   const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  //   if (newWindow) newWindow.opener = null;
  // };

  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open1 = Boolean(anchorEl);
  useEffect(() => {
    GetDocument();
  }, []);
  return (
    <>
      {data?.map((arg) => {
        {/* console.log("arggg", arg); */}
        return (
          <>
            <div class="card shadow-none border mt-4  bg_blue">
              <div class="row ">
                <div class="col-md-3">
                  {/* <img
                    class="img-fluid image-radius"
                    src={arg.doumentUrl}
                    alt=""
                  /> */}
                  <div
                  // onClick={ImageClick} className='pos_46'
                  >
                                
                                  <img
                                    
                                    src={arg.doumentUrl}
                                    alt="Error in Loading Image"
                                    class="img-fluid d-block w_46"
                                  />
                                
                                {/* <Popover
                                  id="mouse-over-popover"
                                  sx={{
                                    pointerEvents: "none",
                                    zIndex: 100000,
                                  }}
                                  open={open1}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <img style={{height:"600px",center: "300px"}}
                                    
                                 
                                    src={arg.doumentUrl}
                                    alt="Error in Loading Image"
                                    class="img-fluid d-block"
                                  />
                                </Popover> */}
                              </div>
                           

                  {/* <button
                    onClick={() => openInNewTab(arg.doumentUrl)}
                    className="btn btn-primary d-block view_image m-0 mx-auto mt-2"
                  >
                    View Image
                  </button> */}
                </div>
                <div class="col-md-9 pt-3">
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label
                        for="exampleInputEmail1"
                        class="form-label m-0 labelfont"
                      >
                        Document Name
                      </label>
                      <p class="sizefont m-0">{arg.documentType}</p>
                    </div>
                    <div class="col-md-4">
                      <label
                        for="exampleInputEmail1"
                        class="form-label m-0 labelfont"
                        
                      >
                        Upload Date/Time
                      </label>
                      {/* <p class="sizefont m-0">{arg.uploadDate}</p> */}
                      <p class="sizefont m-0">
                        {dateFormatter(arg.uploadDate)}
                      </p>
                    </div>
                    <div class="col-md-4">
                      <label
                        for="exampleInputEmail1"
                        class="form-label m-0 labelfont"
                      >
                        Verified Date/Time
                      </label>
                      <p class="sizefont m-0">
                    

                      {/* {alert(arg.verifiedDate)} */}
                      {dateFormatter(arg?.verifiedDate)}
                       </p>
                      
                                            {/* <p class="sizefont m-0">{dateFormatter(arg.verifiedDate)} </p> */}

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label
                        for="exampleInputEmail1"
                        class="form-label m-0 labelfont"
                      >
                        Status
                      </label>
                      {/* <p class="sizefont m-0 ">{arg?.status}</p> */}

                      {arg.status==true?(<>
                                <span class="badge bg-success activate_2">Approved</span>
                              </>):(<>
                                {/* <span class="badge bg-danger">Deactivated</span> */}
                                <span class="badge bg-warning text-dark">Pending</span>
                              </>)}
                      {/* {alert(arg.status)} */}
                    </div>
                    <div class="col-md-4">
                      <label
                        for="exampleInputEmail1"
                        class="form-label m-0 labelfont"
                      >
                        Rejected Reason
                      </label>
                      <p class="sizefont m-0">{arg.rejectedReason}</p>
                      {/* <p class="sizefont ">{arg?.status}</p> */}

                    </div>
                    <div class="col-md-4">
                      <label
                        for="exampleInputEmail1"
                        class="form-label m-0 labelfont"
                      >
                        Id
                      </label>
                      <p class="sizefont m-0">{arg.id}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })}

      {/* <div class="card shadow-none border mt-4  bg_blue">
        <div class="row ">
          <div class="col-md-3">
            <img class="img-fluid image-radius" src={documentimg} alt="" />
          </div>
          <div class="col-md-9 pt-3">
            <div class="row mb-3">
              <div class="col-md-4">
                <label
                  for="exampleInputEmail1"
                  class="form-label m-0 labelfont"
                >
                  Document Name
                </label>
                <p class="sizefont m-0">Loremipsum dolor</p>
              </div>
              <div class="col-md-4">
                <label
                  for="exampleInputEmail1"
                  class="form-label m-0 labelfont"
                >
                  Upload Date/Time
                </label>
                <p class="sizefont m-0">Loremipsum dolor</p>
              </div>
              <div class="col-md-4">
                <label
                  for="exampleInputEmail1"
                  class="form-label m-0 labelfont"
                >
                  Approve Date/Time
                </label>
                <p class="sizefont m-0">Loremipsum dolor</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label
                  for="exampleInputEmail1"
                  class="form-label m-0 labelfont"
                >
                  Status
                </label>
                <p class="sizefont m-0">Loremipsum dolor</p>
              </div>
              <div class="col-md-4">
                <label
                  for="exampleInputEmail1"
                  class="form-label m-0 labelfont"
                >
                  Verified By
                </label>
                <p class="sizefont m-0">Loremipsum dolor</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Document;
